import { BaseResourceModel } from '../../models/base-resource.model';
import { Exercicio } from "../comum/exercicio.model";
import { Orgao } from "../comum/orgao.model";

export class CadastroParcelamentoRPPS extends BaseResourceModel {
  constructor(
    public numero_parcelamento?: number,
    public mes?: number,
    public data_parcelamento?: Date,
    public data_vencimento?: Date,
    public valor_total?: number,
    public qtd_parcelas?: number,
    public observacao?: string,
    public orgao?: Orgao,
    public exercicio?: Exercicio) {
    super();
  }
  static converteJson(json: any): CadastroParcelamentoRPPS {
    return Object.assign(new CadastroParcelamentoRPPS(), json);
  }
}